import { render, staticRenderFns } from "./PaperMag.vue?vue&type=template&id=e9c7f49e&scoped=true"
import script from "./PaperMag.vue?vue&type=script&lang=js"
export * from "./PaperMag.vue?vue&type=script&lang=js"
import style0 from "./PaperMag.vue?vue&type=style&index=0&id=e9c7f49e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7f49e",
  null
  
)

export default component.exports